var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"sidebar-rail",attrs:{"type":"button","data-sidebar":"rail","data-slot":"sidebar-rail","aria-label":"Toggle Sidebar","title":"Toggle Sidebar","tabindex":-1},on:{"click":_vm.toggleSidebar}})
}
var staticRenderFns = []

export { render, staticRenderFns }